var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediumIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2435 15.8379H3.87854C3.5952 15.8379 3.39326 15.7118 3.2727 15.4596C3.15215 15.2074 3.17993 14.9693 3.35604 14.7454L6.82687 10.3254C6.90187 10.2293 6.93937 10.1224 6.93937 10.0046C6.93937 9.88681 6.90187 9.77986 6.82687 9.68375L3.35604 5.24875C3.17993 5.02486 3.15215 4.78681 3.2727 4.53458C3.39326 4.28236 3.5952 4.15625 3.87854 4.15625H12.2277C12.4383 4.15625 12.6377 4.19903 12.826 4.28458C13.0138 4.37069 13.168 4.49653 13.2885 4.66208L16.8469 9.16542C17.0474 9.41431 17.1477 9.69431 17.1477 10.0054C17.1477 10.3165 17.0471 10.5965 16.846 10.8454L13.3044 15.3321C13.1838 15.4982 13.0294 15.624 12.841 15.7096C12.6533 15.7957 12.4541 15.8379 12.2435 15.8379Z",
    fill: "#FCCA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumIcon);
export default __webpack_public_path__ + "static/media/medium-icon.8e1dffa4053f76b72e7dea8f2d4dfb45.svg";
export { ForwardRef as ReactComponent };